import React from "react";
import PropTypes from "prop-types";
import { Formik } from "formik";
import * as Yup from "yup";
import Grid from "@mui/material/Grid";
import { Input, AutoSaveField as Field, NumberFormat } from "../../../../../../components/Form";

import { ContinueButton } from "../../../../../../components/Buttons/ContinueButton";
import { FormContainer, ButtonWrapper } from "./styled";
import { CREDIT_PERIOD_MAX_LENGTH } from "./constants";
import { ScrollToError } from "components/ScrollToError";

const companyBusinessRelationshipsSchema = () =>
  Yup.object().shape({
    creditPeriodSuppliers: Yup.string()
      .nullable()
      .max(CREDIT_PERIOD_MAX_LENGTH, `Maximum ${CREDIT_PERIOD_MAX_LENGTH} characters allowed`),
    creditPeriodCustomers: Yup.string()
      .nullable()
      .max(CREDIT_PERIOD_MAX_LENGTH, `Maximum ${CREDIT_PERIOD_MAX_LENGTH} characters allowed`)
  });

const intialSchema = {
  creditPeriodSuppliers: "",
  creditPeriodCustomers: ""
};

export const CompanyBusinessRelationshipsComponent = ({ handleContinue }) => {
  const roProspectPath = "roProspect.organizationInfoRO";
  return (
    <Formik
      initialValues={intialSchema}
      onSubmit={handleContinue}
      validationSchema={companyBusinessRelationshipsSchema}
      validateOnChange={false}
    >
      {({ handleSubmit }) => (
        <FormContainer onSubmit={handleSubmit}>
          <ScrollToError />
          <Grid container spacing={3}>
            <Grid item sm={12} xs={12}>
              <h5> Credit Period in Days </h5>
            </Grid>
            <Grid item sm={8} xs={12}>
              <Field
                name="creditPeriodSuppliers"
                label="CREDIT PERIOD (AVERAGE) Suppliers"
                placeholder="CREDIT PERIOD (AVERAGE) Suppliers"
                path={`${roProspectPath}.creditPeriodSuppliers`}
                component={Input}
                InputProps={{
                  inputComponent: NumberFormat,
                  inputProps: { tabIndex: 0 }
                }}
              />
            </Grid>
            <Grid item sm={8} xs={12}>
              <Field
                name="creditPeriodCustomers"
                label="CREDIT PERIOD (AVERAGE) Customers"
                placeholder="CREDIT PERIOD (AVERAGE) Customers"
                path={`${roProspectPath}.creditPeriodCustomers`}
                component={Input}
                InputProps={{
                  inputComponent: NumberFormat,
                  inputProps: { tabIndex: 0 }
                }}
              />
            </Grid>
          </Grid>

          <ButtonWrapper>
            <ContinueButton type="submit" />
          </ButtonWrapper>
        </FormContainer>
      )}
    </Formik>
  );
};

CompanyBusinessRelationshipsComponent.propTypes = {
  /**
   * Function to handle form submission and continue to the next step
   * @returns {void}
   */
  handleContinue: PropTypes.func.isRequired
};
